export default __webpack_public_path__ + "static/main8-table-df15023f97cc69725445aa52d73e03d1.png";